<template>
  <div class="wrapper">
    <b-card no-body>
      <div class="inner">
        <h3 v-html="title"></h3>
        <p v-html="paragraph"></p>
      </div>
    </b-card>
    <img class="arrow" src="@/assets/images/even-arrow.svg" alt />
    <img class="img" :src="src" alt />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    paragraph: String,
    src: String
  }
};
</script>